<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Havalimanı Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek Iata Kodu benzersiz olmalıdır...</span
              >
            </div>
          </b-alert>
          <!-- <b-button
              class="float-right"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              :to="`/users/create`"
            >
              Yeni Kullanıcı Ekle
            </b-button> -->
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Havalimanı Ekleme Formu">
            <b-row>
              <b-col md="12">
                <b-form-group label="Iata Kodu" label-for="iataCode">
                  <validation-provider
                    #default="{ errors }"
                    vid="username"
                    :rules="{ required: true }"
                    name="Iata Kodu"
                  >
                    <b-form-input
                      id="iataCode"
                      type="text"
                      v-model="iataCode"
                      placeholder="Iata Kodu"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Havalimanı Adı" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    vid="name"
                    :rules="{ required: true }"
                    name="Havalimanı Adı"
                  >
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="name"
                      placeholder="Havalimanı Adı"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Enlem" label-for="lat">
                  <validation-provider
                    #default="{ errors }"
                    vid="lat"
                    :rules="{ required: true }"
                    name="Enlem"
                  >
                    <b-form-input
                      id="lat"
                      type="text"
                      v-model="lat"
                      placeholder="Enlem"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Boylam" label-for="long">
                  <validation-provider
                    #default="{ errors }"
                    vid="long"
                    :rules="{ required: true }"
                    name="Boylam"
                  >
                    <b-form-input
                      id="long"
                      type="text"
                      v-model="long"
                      placeholder="Boylam"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Çap (KM)" label-for="range">
                  <validation-provider
                    #default="{ errors }"
                    vid="range"
                    :rules="{ required: true, min: 1, max: 2 }"
                    name="Çap (KM)"
                  >
                    <b-form-input
                      id="range"
                      type="number"
                      v-model="range"
                      placeholder="1"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false, false)"
                  >
                    <b-spinner v-if="spinner === true" small />
                    {{ spinner === true ? "Kaydediliyor" : "Kaydet" }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Havalimanları">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>IATA KODU</th>
                    <th>HAVALİMANI ADI</th>
                    <th>ENLEM</th>
                    <th>BOYLAM</th>
                    <th>ÇAP</th>
                    <th>İŞLEMLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                  <tr v-for="airport in airports" :key="airport.id">
                    <td>{{ airport.id }}</td>
                    <td>{{ airport.iataCode }}</td>
                    <td>{{ airport.name }}</td>
                    <td>{{ airport.lat }}</td>
                    <td>{{ airport.long }}</td>
                    <td>{{ airport.range }} KM</td>
                    <!-- <td>
                      <b-button-group class="mr-2">
                        <b-button
                          v-for="language in languages"
                          :key="language.code"
                          @click="action(airport, language.code)"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          :variant="
                            airport.languages.find((element) => element == language.code)
                              ? 'outline-warning'
                              : 'outline-secondary'
                          "
                          :title="
                            airport.languages.find((element) => element == language.code)
                              ? 'Düzenle'
                              : 'Ekle'
                          "
                        >
                          {{ language.code.toUpperCase() }}
                        </b-button>
                      </b-button-group>
                    </td> -->
                    <td>
                      <b-button-group class="float-right">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-danger"
                          class="btn-icon rounded-circle"
                          @click="deleteConfirmText(airport.id)"
                        >
                          <feather-icon icon="TrashIcon" /> </b-button
                      ></b-button-group>
                    </td>
                    <td>{{ airport.createdAt }}</td>
                  </tr>
                  <thead>
                    <th>#</th>
                    <th>IATA KODU</th>
                    <th>HAVALİMANI ADI</th>
                    <th>ENLEM</th>
                    <th>BOYLAM</th>
                    <th>ÇAP </th>
                    <th>İŞLEMLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="1"
                    :total-rows="rows"
                    :per-page="12"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getAirports(value)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BPagination,
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
  BBadge,
  BButtonGroup,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
const endpoints = new Endpoints();

export default {
  components: {
    BPagination,
    BBadge,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    BButtonGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rows: 100,
      lat: "",
      long: "",
      name: "",
      range: 1,
      iataCode: "",
      airports: [],
      languages: [],
      spinner: false,
      baseUrl: settings.apiBaseUrl,
      request: [],
      currentPage: 1,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getAirports(newVal);
      },
      deep: true,
    },
  },
  methods: {
    getAirports(page) {
      endpoints
        .getAirports(page, this.$i18n.locale, () => {})
        .then((data) => {
          this.airports = [];
          this.airports = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText() {
      this.$swal({
        title: "Kayıt?",
        text: "Yeni havalimanını kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;

          endpoints
            .postAirports(
              {
                lat: this.lat,
                long: this.long,
                name: this.name,
                range: this.range,
                iataCode: this.iataCode,
              },
              this.$i18n.locale,
              () => {}
            )
            .then((data) => {
              this.spinner = false;

              if (!data.status) {
                this.$swal({
                  icon: "error",
                  title: "Hata!",
                  text: "Havalimanı zaten kayıtlı.",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {});
              } else {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Yeni havalimanı eklendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.getAirports(1);
                    this.name = "";
                    this.lat = "";
                    this.long = "";
                    this.range = 1;
                    this.iataCode = "";
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Havalimanını silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteAirports(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getAirports(1);
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Havalimanı silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  mounted() {
    this.getLanguages();
    this.getAirports(1);
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
